import React from 'react';
import PropTypes from 'prop-types';
import PlusComponent from '../../shared_components/PlusComponent';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
class AddLoanpartComponent extends React.Component {
  render() {
    return (
      <div onClick={this.props.onClickHandler} className="add-loanpart__container">
        <div className="add-loanpart__button">
          <PlusComponent />
        </div>
        <div className="add-loanpart__text">
          Leningdeel
        </div>
      </div>
    );
  }
}

AddLoanpartComponent.propTypes = {
  onClickHandler: PropTypes.func,
};

AddLoanpartComponent.defaultProps = {
  onClickHandler: () => {},
};

export default AddLoanpartComponent;
